const Spinner = ({ label }) => (
  <div className="root">
    <span className="spinner" role="presentation"></span>
    {label}
    <style jsx>{`
      .root {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .spinner,
      .spinner::after {
        border-radius: 50%;
        width: 1em;
        height: 1em;
      }

      .spinner {
        display: inline-block;
        margin-right: 8px;
        margin-left: -12px;
        border-top: 0.25em solid var(--bgBlueish__fadedText);
        border-right: 0.25em solid var(--bgBlueish__fadedText);
        border-bottom: 0.25em solid var(--bgBlueish__fadedText);
        border-left: 0.25em solid var(--bgHotBlue);
        animation: spinning 1.1s infinite linear;
      }

      @keyframes spinning {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `}</style>
  </div>
);

export function SubmitButton({
  children,
  level = 'primary',
  isLoading = false,
  loadingLabel = '',
  ref2 = undefined,
  ...props
}) {
  return (
    <button className="button" ref={ref2} {...props}>
      {isLoading && <Spinner label={loadingLabel} />}
      <span className={isLoading ? 'children--hidden' : ''}>{children}</span>
      <style jsx>{`
        .button {
          position: relative;
          padding: 0.75em 2em;
          line-height: 1;
          border-radius: 1em;
          font-size: 1em;
          font-weight: 600;
          text-decoration: none;
          white-space: nowrap;
          color: rgba(14, 17, 17, 0.8);
          border: none;
          user-select: none;
          cursor: pointer;
        }

        .button:hover,
        .button:focus {
          color: rgb(14, 17, 17);
          background-color: #02cab3;
          opacity: 0.95;
        }

        .children--hidden {
          opacity: 0;
        }
      `}</style>
      <style jsx>{`
        .button {
          box-shadow: ${level === 'primary'
            ? '0 2px 32px 0 rgba(0, 12, 51, 0.15)'
            : ''};
          background-color: ${level === 'primary'
            ? 'var(--bgHotGreen)'
            : 'var(--bgBlueish__textDim)'};
          color: ${level === 'primary'
            ? 'var(--bgHotGreen__text)'
            : 'var(--bgBlueish__fadedText)'};
        }

        .button:hover,
        .button:focus {
          background-color: ${level === 'primary' ? '#02cab3' : '#cbcfe7'};
        }

        .button:disabled {
          box-shadow: none;
          background-color: var(--bgBlueish__fadedText);
          color: var(--bgBlueish__textDim);
          cursor: default;
        }
      `}</style>
    </button>
  );
}
